module.exports = __webpack_public_path__ + "static/media/conferbot.176e9128.gif";